import { createReducer } from '@reduxjs/toolkit';

import * as Actions from './actions';
import { defaultState, EngineAvailabilityStore } from './store';

export default createReducer<EngineAvailabilityStore>(defaultState, (builder) =>
  builder
    // CHECK_ENGINE_AVAILABILITY itself reduces to nothing: it announces that a
    // check is starting, and no surface asks. A `checking` flag lived here and
    // was never read — it also latched true, because the thunk returns early
    // with no outcome when there is nothing to ask about. State that records a
    // guard nobody implements is worse than no state.
    .addCase(
      Actions.CHECK_ENGINE_AVAILABILITY_SUCCESS,
      (state, { payload }) => ({
        ...state,
        availableIds: payload.availableIds,
      })
    )
    .addCase(Actions.CHECK_ENGINE_AVAILABILITY_FAILURE, (state) => ({
      ...state,
      // availableIds deliberately untouched: a failure is not an answer. It
      // stays null (offer everything), or keeps a previous good answer.
      availableIds: state.availableIds,
    }))
);
